module.exports = __webpack_public_path__ + "static/media/machine_group_yellow.d3ddc322.svg";